import { environment } from './../../../../../environments/environment';
import { PaymentTerminalService } from './../../../../services/payment-terminal/payment-terminal.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { marker } from '../../map/googlemaps/google-maps.component';
import { StorageService } from 'src/app/services/storage/storage.service';
import { KEY_LAST_CATEGORY_SELECT } from '../../payment-terminal/payment-terminal.page';

@Component({
  selector: 'app-brand-detail',
  templateUrl: './brand-detail.page.html',
  styleUrls: ['./brand-detail.page.scss'],
})
export class BrandDetailPage implements OnInit {
  loading = true;
  idCategory
  last_category
  idBrand
  description
  locations
  brand 

  public_id_cloudinary = environment.public_id_cloudinary
  constructor(
    public languageService: LanguagesService
    , private route: ActivatedRoute
    , private brandsService: PaymentTerminalService
    , private storageService: StorageService

  ) { }
  
  ngOnInit() {

  }
  ionViewDidEnter() {
    this.idCategory = this.route.snapshot.paramMap.get('id');
    this.idBrand = this.route.snapshot.paramMap.get('id-brand');

    console.log('idCategory', this.idCategory);
    console.log('idBrand', this.idBrand);

    (async () => {
      await this.getDetail();
      this.last_category = await this.storageService.get(KEY_LAST_CATEGORY_SELECT)
    })()
  }

  async getDetail() {
    const brandsData: any = await this.brandsService.getBrandDetail(this.idBrand)
    console.log(brandsData);
    if (brandsData) {
      this.brand = brandsData
      // this.description = brandsData.description
      console.log("brandsData.description == ",brandsData.description);
      
      if (brandsData.locations) {
        this.locations = brandsData.locations
      } 

    }
    this.loading = false;

  }
}
